import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from 'anatoliapps-angular/services';

import { NotificationChannel, NotificationPreference, NotificationPreferenceIdentifier, NotificationTopic, NotificationTopicPreferences } from 'hakikat/models';
import { PaginatedResult, PaginationOptions } from 'hakikat/shared';
import { API_CONFIG } from 'hakikat/utils';

export interface NotificationIdentifier extends Omit<NotificationPreferenceIdentifier, 'uid'> { }

@Injectable({
  providedIn: 'root'
})
export class NotificationPreferencesService extends ApiService {

  //#region Endpoints
  readonly #NOTIFICATION_PREFERENCES_ENDPOINT = 'notification-preferences';
  //#endregion

  //#region Constructor
  constructor() { super(API_CONFIG.apiUrl); }
  //#endregion

  //#region Methods
  public getPreferences(identifier?: NotificationIdentifier): Observable<NotificationPreference> {
    return this.get<NotificationPreference>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}`, identifier ? { ...identifier } : undefined);
  }

  public updatePreferences(topics?: NotificationTopicPreferences): Observable<NotificationPreference> {
    return this.put<NotificationPreference>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}`, { topics });
  }

  public subscribe(identifier: NotificationIdentifier, topic: NotificationTopic, channel: NotificationChannel): Observable<NotificationPreference> {
    return this.post<NotificationPreference>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}/subscribe`, {
      ...identifier, topic, channel
    });
  }

  public unsubscribe(identifier: NotificationIdentifier, topic: NotificationTopic, channel: NotificationChannel): Observable<NotificationPreference> {
    return this.post<NotificationPreference>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}/unsubscribe`, {
      ...identifier, topic, channel
    });
  }

  public unsubscribeWithToken(token: string): Observable<NotificationPreference> {
    return this.get<NotificationPreference>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}/unsubscribe`, { token });
  }

  public listSubscriptions(topic: NotificationTopic, channel: NotificationChannel, paginationOptions?: PaginationOptions): Observable<PaginatedResult<NotificationPreference>> {
    return this.get<PaginatedResult<NotificationPreference>>(`${this.#NOTIFICATION_PREFERENCES_ENDPOINT}/subscribers`, {
      topic, channel, ...(paginationOptions && { ...paginationOptions })
    });
  }
  //#endregion

}
